export default __webpack_public_path__ + "static/media/perse2.41d14e9f.png";